module.exports = __webpack_public_path__ + "img/about/80243-013.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-013.png
// module id = 23
// module chunks = 0